export const tourText = {
  workspaceInsights: {
    title: 'Workspace Insights',
    description:
      'See your current AI credit and storage balances at a glance. Use quick links to top up credits, customize workspace colors, or configure LTI and SCORM integrations.',
  },
  userInsights: {
    title: 'User Insights',
    description:
      'Track how many user and creator seats are available in your workspace, and add more as needed.',
  },
  courseInsights: {
    title: 'Course Insights',
    description:
      'Get a snapshot of your created and published courses, along with average learner scores and participation.',
  },
};
